import { render, staticRenderFns } from "./OwlBtnSave.vue?vue&type=template&id=ca61d604"
import script from "./OwlBtnSave.vue?vue&type=script&lang=js"
export * from "./OwlBtnSave.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports